var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('button',{on:{"click":function($event){return _vm.download(_vm.btnFont)}}},[_vm._v(_vm._s(_vm.btnFont))])])
}
var staticRenderFns = []

export { render, staticRenderFns }